export default __webpack_public_path__ + "81cb1472e6375af1505d31fcbd3bd205.jpg";